export const DEFAULT_TRADE_B_ITEMS = [
  "Spirit of the Lion",
  "Spirit of the Panther",
  "Spirit of the Rhino",
  "Spirit of the Zebra",
  "Achilles Outpost Augmenter",
  "Station Engineer's Augmenter",
  "Adamantiumized Bank",
  "Adamantiumized Protector",
  "Adamantiumized Charger",
  "Andaman Overloader",
  "Annihilator Overloader",
  "Volatile Projectile Overcharger",
  "Energy Harmonization Overcharger",
  "Plasma Conduits Overcharger",
  "Andaman Pulse Gun",
  "Achilles Pulse Gun",
  "Annihilator Pulse Gun",
  "Achilles MagCannon",
  "Adamantium Reinforced Energy Dampener+",
  "Adamantium Reinforced Heat Dampener+",
  "Adamantium Reinforced Mining Dampener+",
  "Adamantium Reinforced Radiation Dampener+",
  "Adamantium Reinforced Surgical Dampener+",
  "Adamantium Reinforced Physical Dampener+",
  "Energy Dampener+",
  "Heat Dampener+",
  "Mining Dampener+",
  "Radiation Dampener+",
  "Surgical Dampener+",
  "Physical Dampener+",
  "Adonis Extermination",
  "Andaman Extermination",
  "Achilles Extermination",
  "Annihilator Extermination",
  "Radiation Dampener"
];
